import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";
import { userFarmDetail } from "../../../config/farmDetails";
import { updateCounterPartyAction } from "../../../modules/counterparties/action";
import { validForm } from "../../FormElement/FormValidator";
import CounterpartyForm from "./CounterpartyForm";

class EditCounterParty extends Component {
  state = {
    counterPartyInfo: {
      farmId: userFarmDetail().id || this.props.MainFarmId,
      name: "",
      typeId: ""
    },
    formErrors: {
      name: "",
      typeId: ""
    },
    isValid: true,
    successMessage: "",
    errorMessage: {},
    edited: false
  };

  componentDidUpdate = () => {
    if (this.state.edited) {
      window.onbeforeunload = () => true;
    } else {
      window.onbeforeunload = undefined;
    }
  };

  componentWillUnmount() {
    window.onbeforeunload = undefined;
  }

  componentWillMount() {
    const {
      id,
      name,
      counterpartTypeResponseDTO = {},
      phoneNumber
    } = this.props.selectedParty;
    this.setState({
      counterPartyInfo: {
        id,
        name,
        typeId: counterpartTypeResponseDTO.id,
        phoneNumber
      }
    });
  }

  handleChange = event => {
    if (!this.state.edited) this.setState({ edited: true });
    const { name, value } = event.target;
    if (name === "phoneNumber") {
      if (value.match(/^\d{0,15}?$/)) {
        this.updateState(name, value);
      }
    } else if (name === "name") {
      if (value.match(/^(\w|\ ){0,51}$/)) {
        this.updateState(name, value);
      }
    } else {
      this.updateState(name, value);
    }
  };

  updateState = (name, value) => {
    this.setState(
      prevState => {
        return {
          counterPartyInfo: {
            ...prevState.counterPartyInfo,
            [name]: value
          }
        };
      },
      () => {
        const { counterPartyInfo } = this.state;
        this.setState({
          isValid: validForm(this.state.formErrors, counterPartyInfo)
        });
      }
    );
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.partyUpdated && nextProps.partyUpdated.status === 200) {
      this.setState({ successMessage: true });
    }
  }

  updateCounterParty = e => {
    e.preventDefault();
    const { counterPartyInfo, isValid } = this.state;
    this.setState({ isValid: true, edited: false });
    (counterPartyInfo.farmId = userFarmDetail().id || this.props.MainFarmId),
      this.props.updateCounterPartyAction(counterPartyInfo);
  };
  render() {
    const { successMessage, counterPartyInfo, isValid, edited } = this.state;
    if (successMessage) {
      return <Redirect to="/farmsetup/counterparties" />;
    }
    return (
      <CounterpartyForm
        buttonLabel="Update"
        formLabel="Edit counterpart"
        counterPartyInfo={counterPartyInfo}
        handleChange={this.handleChange}
        //handleError={this.handleError}
        createCounterparty={this.updateCounterParty}
        isValid={isValid}
        edited={edited}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    selectedParty: state.counterPartyReducer.selectedParty,
    partyUpdated: state.counterPartyReducer.partyUpdated,
    MainFarmId: state.FarmManagementReducer.MainFarmId
  };
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ updateCounterPartyAction }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditCounterParty);



// WEBPACK FOOTER //
// ./src/components/private/Counterparties/EditCounterParty.js